/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import StyledSignup from "./StyledSignup";
import { Box, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import TextFeild from "../../components/CommonComponents/TextFeild";
import { INPUT_LABELS } from "../../constants/lang";

const ContactSocials = ({ control, errors }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <StyledSignup>
      <Box>
        <Typography className='step-header'>Basic Information</Typography>
      </Box>
      <Box className='signup-textfeilds'>
        <Box className='signup-store'>
          <Box className='text-feilds'>
            <Controller
              name='instagram'
              control={control}
              defaultValue=''
              render={({ field }) => (
                <TextFeild
                  {...field}
                  id='instagram'
                  label={INPUT_LABELS.instagram}
                  placeholder='Enter a valid Instagram URL (https://)'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  error={!!errors.instagram}
                  helperText={errors.instagram?.message}
                />
              )}
            />
          </Box>
          <Box className='text-feilds'>
            <Controller
              name='other'
              control={control}
              defaultValue=''
              render={({ field }) => (
                <TextFeild
                  {...field}
                  id='other'
                  label={INPUT_LABELS.other}
                  placeholder='Enter your Other profile URL'
                  variant='outlined'
                  fullWidth
                  margin='normal'
                  error={!!errors.other}
                  helperText={errors.other?.message}
                />
              )}
            />
          </Box>
        </Box>
      </Box>
    </StyledSignup>
  );
};

export default ContactSocials;
